import React, { useState } from 'react';
import { Box, Container, Typography, TextField, Button, Grid, Paper, Divider, Tabs, Tab } from '@mui/material';
import PageTitle from '../components/PageTitle';

const Donation = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleDonationSubmit = (event) => {
    event.preventDefault();
    alert('Thank you for your donation!');
  };

  return (
    <>
      <PageTitle title="Donate" />
      <Box sx={{ bgcolor: 'background.default', py: 6 }}>
        <Container maxWidth="md">
          <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3, textAlign: 'center' }}>
              Donate to Shoora Welfare
            </Typography>
            <Typography variant="body1" sx={{ mb: 4, textAlign: 'center' }}>
              Your generous contributions help us empower communities and bring positive change. Donations made to Shoora Welfare are eligible for tax exemption under Section 80G of the Income Tax Act.
            </Typography>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              centered
              sx={{ mb: 4 }}
            >
              <Tab label="Donate via Bank Transfer" />
              <Tab label="Donate via Online Form" />
            </Tabs>
            {tabValue === 0 && (
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, textAlign: 'center' }}>
                  Bank Account Details
                </Typography>
                <Typography variant="body2" sx={{ mb: 1, textAlign: 'center', color: 'text.secondary' }}>
                  <strong>Account Name:</strong> Shoora Welfare Foundation
                </Typography>
                <Typography variant="body2" sx={{ mb: 1, textAlign: 'center', color: 'text.secondary' }}>
                  <strong>Bank Name:</strong> HDFC BANK
                </Typography>
                <Typography variant="body2" sx={{ mb: 1, textAlign: 'center', color: 'text.secondary' }}>
                  <strong>Account Number:</strong> 50200035927767
                </Typography>
                <Typography variant="body2" sx={{ mb: 1, textAlign: 'center', color: 'text.secondary' }}>
                  <strong>IFSC Code:</strong> HDFC0001087
                </Typography>
                <Typography variant="body2" sx={{ mb: 4, textAlign: 'center', color: 'text.secondary' }}>
                  <strong>Branch:</strong> LAHURABIR, VARANASI
                </Typography>
                <Typography variant="body1" sx={{ mb: 4, textAlign: 'center', color: 'text.secondary' }}>
                  After transferring the donation amount, please share the transaction details along with a valid KYC proof (e.g., Aadhaar, PAN) to our registered email address: <strong>shoorawelfare@gmail.com</strong>.
                </Typography>
                <Typography variant="body1" sx={{ textAlign: 'center', color: 'text.secondary' }}>
                  You will receive the donation receipt within 3 working days.
                </Typography>
              </Box>
            )}
            {tabValue === 1 && (
              <form onSubmit={handleDonationSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Full Name"
                      variant="outlined"
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Email Address"
                      type="email"
                      variant="outlined"
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Phone Number"
                      type="tel"
                      variant="outlined"
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Donation Amount (INR)"
                      type="number"
                      variant="outlined"
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      fullWidth
                      sx={{ py: 1.5, fontWeight: 'bold' }}
                    >
                      Donate Now
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
            <Divider sx={{ my: 4 }} />
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, textAlign: 'center' }}>
                Legal and Compliance Information
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, textAlign: 'center', color: 'text.secondary' }}>
                <strong>80G Registration:</strong> ABBCS1476RF20251 (Donations to Shoora Welfare are eligible for tax exemption under Section 80G of the Income Tax Act.)
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, textAlign: 'center', color: 'text.secondary' }}>
                <strong>12A Registration:</strong> ABBCS1476RE20241 (Shoora Welfare is registered under Section 12A of the Income Tax Act.)
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, textAlign: 'center', color: 'text.secondary' }}>
                <strong>CIN:</strong> U93000UP2018NPL110369
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, textAlign: 'center', color: 'text.secondary' }}>
                <strong>TAN NO:</strong> ALDS07709C
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, textAlign: 'center', color: 'text.secondary' }}>
                <strong>Udyam Registration Number:</strong> UDYAM-UP-03-0096792
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, textAlign: 'center', color: 'text.secondary' }}>
                <strong>Registered Address:</strong> 120/40/2B/1A, Kasari Masari, Prayagraj, U.P 211011
              </Typography>
              <Typography variant="body2" sx={{ textAlign: 'center', color: 'text.secondary' }}>
                For any queries, please contact us at <strong>shoorawelfare@gmail.com</strong> or call us at <strong>(+91) 8299866226</strong>.
              </Typography>
            </Box>
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default Donation;
